import gql from 'graphql-tag';

export default gql`
  mutation CreateContactUs($data: ContactUsCreateInput!) {
    createContactUs(data: $data) {
      id
      name
      number
      email
      status
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/CreateContactUs.ts